
import { Grid, TextField } from "@mui/material";
import { useState } from "react";
import { startSavingCliente } from "../../../services";
import { BotonesAndCargando } from "../../components/botones";
import { LayoutCrearDoc } from "../../layouts";

import Swal from 'sweetalert2';




const initCliente = {
    nombre: "",
    cedula: "",
    ciudad: "",
    direccion: "",
    movil: "",
    establecimiento: "",
    profesion: "",
    email: "",
};



export const CrearClientes = () => {


    const [cargando, setCargando] = useState(false);
    const [formUsuario, setFormUsuario ] = useState( initCliente )
    const { nombre, cedula, ciudad, direccion, movil, establecimiento, email, profesion } = formUsuario;


    const handleInputChange = ({ target }) => {
        setFormUsuario({
            ...formUsuario,
            [target.name]: target.value
        });
    }



    const  handleCrearCliente = async( e ) => {
        e.preventDefault();
        if(nombre.length < 4 ){
            Swal.fire('Error', 'El nombre debe de tener mas de 5 caracteresy es obligatorio', 'error');
            return;
        }
    
        if(email.length < 2 ){
            Swal.fire('Error', 'El email debe ser obligatorio', 'error');
            return;
        }

        setCargando(true);
        const resp = await startSavingCliente(formUsuario);
        setCargando(false);
        if( resp ){ 
            setFormUsuario( initCliente ); 
        }
    }


    return (

        <LayoutCrearDoc titulo={'Crear Cliente'} add={false}>

            <form className="formulario-total" onSubmit={ handleCrearCliente } >
                <Grid container spacing={3} sx={{mt:1}}>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Nombre Cliente'
                            type='text'
                            placeholder='Nombre Cliente'
                            fullWidth
                            name="nombre"
                            value={ nombre }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Cedula Cliente'
                            type='text'
                            placeholder='Cedula Cliente'
                            fullWidth
                            name="cedula"
                            value={ cedula }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Correo Electronico'
                            type='text'
                            placeholder='Correo Electronico'
                            fullWidth
                            name="email"
                            value={ email }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Movil'
                            type='number'
                            placeholder='Movil'
                            fullWidth
                            name="movil"
                            value={ movil }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            variant="outlined"
                            label='Establecimiento'
                            type='text'
                            placeholder='Establecimiento'
                            fullWidth
                            name="establecimiento"
                            value={ establecimiento }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            variant="outlined"
                            label='Profesión'
                            type='text'
                            placeholder='Profesión'
                            fullWidth
                            name="profesion"
                            value={ profesion }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            variant="outlined"
                            label='Ciudad'
                            type='text'
                            placeholder='Ciudad'
                            fullWidth
                            name="ciudad"
                            value={ ciudad }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Dirección'
                            type='text'
                            placeholder='Dirección'
                            fullWidth
                            name="direccion"
                            value={ direccion }
                            onChange={ handleInputChange }
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Crear Cliente'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </LayoutCrearDoc>


    )




}
